import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { DigitsOnlyDirective } from '../../core/directives';
import { passwordValidationMessage } from '../../core/utils/input-validation.util';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [FormsModule, DigitsOnlyDirective],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css'
})
export class ResetPasswordComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private auth = inject(AuthService);

  email = this.route.snapshot.queryParamMap.get('email') ?? '';
  resetOtp = '';
  password = '';
  confirmPassword = '';
  showPassword = false;
  showConfirmPassword = false;
  isSubmitting = false;
  submitted = false;
  errorMessage = '';
  devOtpHint = this.auth.demoOtp;

  resetPassword(): void {
    this.errorMessage = '';

    if (!this.resetOtp.trim()) {
      this.errorMessage = 'Please enter the reset OTP.';
      return;
    }

    if (!this.password || !this.confirmPassword) {
      this.errorMessage = 'Please enter and confirm your new password.';
      return;
    }

    const passwordError = passwordValidationMessage(this.password, true);
    if (passwordError) {
      this.errorMessage = passwordError;
      return;
    }

    if (this.password !== this.confirmPassword) {
      this.errorMessage = 'Passwords do not match.';
      return;
    }

    this.isSubmitting = true;

    this.auth.resetPassword(this.email, this.password, this.resetOtp).subscribe({
      next: (result) => {
        this.isSubmitting = false;
        if (!result.success) {
          this.errorMessage = result.message ?? 'Unable to reset password.';
          return;
        }

        this.submitted = true;
      },
      error: () => {
        this.isSubmitting = false;
        this.errorMessage = 'Unable to reset password.';
      }
    });
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPassword(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  backToLogin(): void {
    this.router.navigate(['/login']);
  }
}
